import { render, staticRenderFns } from "./send-reports-confirmation.vue?vue&type=template&id=6e472d20&"
import script from "./send-reports-confirmation.vue?vue&type=script&lang=ts&"
export * from "./send-reports-confirmation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports